import { Clipboard, CreditCard } from "react-feather";
import { BadgeCheck, Wallet as WalletIcon, QrCode as QrCodeIcon } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import "./style.css"
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useMessage } from "../../global-components/src";
import Spinner from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { MP_PUBLIC_KEY, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { logEvent } from "../../components/analytics-tracker";
import { errorMessage } from "../../global-components/src/utils/text";
import { PaymentTypes } from "../../global-components/src/types";
import { t } from "../../global-components/src/i18nTranslate";
import { Icon } from "../../global-components/src/components/icon";
import { set } from "lodash";
import { RequestCompanySealStep1 } from "../companies/step1";
import PremiumUserStep1 from "./premium-user-step1";
import { EFI_ACCOUNT_CODE } from "../../utils/vars";

const Premium = () => {
    const { user, setUser } = useAuth();
    const [step, setStep] = useState(1);
    const [oldValue, setOldValue] = useState<string>(sessionStorage.getItem("oldValuePremium") || "");
    const [value, setValue] = useState<string>("");
    const [errorsInput, setErrorsInput] = useState<{ months?: string[]; }>({});
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [loadingVerifyPayment, setLoadingVerifyPayment] = useState(false);
    const [loadingVerifyPaymentSecondPPlan, setLoadingVerifyPaymentSecondPlan] = useState(false);
    const { token } = useAuth();
    const [copiado, setCopiado] = useState(false);
    const [forceShowForm, setForceShowForm] = useState(false);
    // Estados do cartão
    const [cardToken, setCardToken] = useState<string>("");
    const [cardData, setCardData] = useState({
        number: "",
        name: "",
        expiry: "",
        cvv: "",
    });
    const [cardErrors, setCardErrors] = useState<Record<string, string>>({});
    const [tokenizing, setTokenizing] = useState(false);
    const [recorrente, setRecorrente] = useState(false);
    const [detectedBrand, setDetectedBrand] = useState<string>("");
    const [loadingBin, setLoadingBin] = useState(false);
    const [qrCode, setQrCode] = useState<any>(() => {
        const savedQrCode = sessionStorage.getItem("qrCodePremium");
        return savedQrCode ? savedQrCode : null;
    });
    const [copyPaste, setCopyPaste] = useState<string | null>(() => {
        const saved = sessionStorage.getItem("copyPastePremium");
        return saved ? saved : null;
    });
    const [transaction, setTransaction] = useState<any>(() => {
        const saved = sessionStorage.getItem("transactionPremium");
        return saved ? JSON.parse(saved) : null;
    });
    const [months, setMonths] = useState(1);
    const valuePerMonth = user?.is_company ? 49.99 : 9.99;
    const total = months * valuePerMonth;
    const [paymentMethod, setPaymentMethod] = useState<PaymentTypes>("wallet");
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [loadinWallet, setLoadingWallet] = useState<boolean>(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (qrCode) sessionStorage.setItem("qrCodePremium", qrCode);
        if (copyPaste) sessionStorage.setItem("copyPastePremium", copyPaste);
        if (transaction) sessionStorage.setItem("transactionPremium", JSON.stringify(transaction));
        if (total && !qrCode) sessionStorage.setItem("oldValuePremium", String(total));
    }, [qrCode, copyPaste, transaction, total]);

    useEffect(() => {
        if (user?.is_company && !user.is_verified_company){
            navigate("/empresas/solicitar-selo");
            return;
        }
    }, [user]);

    useEffect(() => {
        setLoadingWallet(true);
        axios.get(`${PACOCA_API_URL}/wallet`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            setWalletBalance(Number(res.data.balance));
        }).finally(() => {
            setLoadingWallet(false);
        });
    }, []);

    const copyLink = async () => {
        if(!copyPaste) return;
        try {
            await navigator.clipboard.writeText(copyPaste);
            setCopiado(true);
            setTimeout(() => setCopiado(false), 2000);
        } catch (err) {
            console.error(err);
        }
    };


    // Detecta a bandeira pelo número
    const detectBrand = (number: string): string => {
        const n = number.replace(/\s/g, "");
        if (/^4/.test(n)) return "visa";
        if (/^5[1-5]/.test(n)) return "mastercard";
        if (/^3[47]/.test(n)) return "amex";
        if (/^(36|38|30[0-5])/.test(n)) return "diners";
        if (/^6(?:011|5)/.test(n)) return "discover";
        if (/^(606282|3841)/.test(n)) return "hipercard";
        if (/^(384100|384140|384160|606282|637095)/.test(n)) return "elo";
        return "visa";
    };

    // Máscara para número do cartão
    const maskCardNumber = (value: string) =>
        value.replace(/\D/g, "").slice(0, 16).replace(/(.{4})/g, "$1 ").trim();

    // Máscara para validade
    const maskExpiry = (value: string) =>
        value.replace(/\D/g, "").slice(0, 4).replace(/^(\d{2})(\d)/, "$1/$2");

    useEffect(() => {
        const interval = setInterval(() => {
            if(transaction?.gateway_txid) verifyPayment();
        }, 500); // Verifica a cada 5 segundos

        return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
    }, [transaction]);

    useEffect(() => {
        if(total && !qrCode) setOldValue(months * valuePerMonth + "")
        if (total && !qrCode) sessionStorage.setItem("oldValuePremium", String(total));
    }, [months]);


    const verifyPayment = async (manual = false) => {
        if(manual) setLoadingVerifyPayment(true);
        if(!manual && (loadingVerifyPayment || loadingVerifyPaymentSecondPPlan)) return;              
        setLoadingVerifyPaymentSecondPlan(true);
        
        try {
            const response = await axios.post(`${PACOCA_API_URL}/verified/verify-payment`, {
                gateway_txid: transaction.gateway_txid,
            },{
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            });

            if(response.data.status == "completed"){
                setMessage(t("premium.paymentConfirmed"), "success");
                cancel()
                navigate(`/@${user?.user_name}`);
                return;
            }

            if(manual){
                setMessage(t("premium.paymentPending"), "warning");
            }
            
        } catch (err: any) {
            const messageError = errorMessage(err);
                                    
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
            } else {
                setMessage(messageError, "error")
            }
            console.error(messageError);
            console.error(err);
        } finally {
            setLoadingVerifyPayment(false);
            setLoadingVerifyPaymentSecondPlan(false);
        }
    };

    const cancel = () =>{
        setStep(1);
        setOldValue("");
        setValue("");
        setLoading(false);
        setQrCode(null);
        setCopyPaste(null);
        setLoading(false);
        setTransaction(null);
        setLoadingVerifyPayment(false);

        sessionStorage.removeItem("qrCodePremium")
        sessionStorage.removeItem("copyPastePremium")
        sessionStorage.removeItem("transactionPremium")
        sessionStorage.removeItem("oldValuePremium")
    }


    const submit = async () =>{
        setLoading(true);
        setErrorsInput({});
        setMessage("", "error");

        const value = Number(months);

        // validações
        if (!Number.isFinite(value)) {
            setErrorsInput({ months: [t("errors.input.invalid", { field: t("premium.duration") })] });
            setLoading(false);
            return;
        }

        if (!Number.isInteger(value)) {
            setErrorsInput({ months: [t("errors.input.invalid", { field: t("premium.duration") })] });
            setLoading(false);
            return;
        }

        if (value < 1 || value > 12) {
            setErrorsInput({ months: [t("errors.input.invalid", { field: t("premium.duration") })] });
            setLoading(false);
            return;
        }

        if (!detectedBrand && paymentMethod === "mercadopago_card") {
            setCardErrors(e => ({ ...e, number: t("errors.input.invalid", { field: t("generics.value") }) }));
            setLoading(false);
            return;
        }

        // Validação extra para cartão
        if (paymentMethod === "mercadopago_card") {
            const errs: Record<string, string> = {};
            const rawNumber = cardData.number.replace(/\s/g, "");
            const [expMonth, expYear] = cardData.expiry.split("/");

            if (rawNumber.length < 16)      errs.number = t("premium.invalidCardNumber");
            if (!cardData.name.trim())      errs.name   = t("premium.cardNameRequired");
            if (cardData.expiry.length < 5) errs.expiry = t("premium.invalidExpiration");
            if (cardData.cvv.length < 3)    errs.cvv    = t("premium.invalidCvv");

            if (Object.keys(errs).length > 0) {
                setCardErrors(errs);
                setLoading(false);
                return;
            }

            try {
                const mp = new (window as any).MercadoPago(MP_PUBLIC_KEY, { locale: "pt-BR" });

                // createCardToken retorna o objeto token direto, não { token, error }
                const tokenResult = await mp.createCardToken({
                    cardNumber:          rawNumber,
                    cardholderName:      cardData.name,
                    cardExpirationMonth: expMonth,
                    cardExpirationYear:  expYear.length === 2 ? `20${expYear}` : expYear,
                    securityCode:        cardData.cvv,
                });

                if (!tokenResult?.id) {
                    throw new Error(t("premium.cardTokenError"));
                }

                const response = await axios.post(`${PACOCA_API_URL}/verified`, {
                    months,
                    gateway:            "mercadopago_card",
                    card_token:         tokenResult.id,   // <-- era cardToken (undefined)
                    payment_method_id:  detectedBrand,
                    recorrente,
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                

                setUser(user ? { ...user, stamps: [...(user?.stamps || []), user?.is_company ? "black" : "blue"] } : user);
                setMessage(
                    recorrente ? t("premium.subscriptionActivated") : t("premium.verifiedAdded"),
                    "success"
                );
                cancel();
                navigate(`/@${user?.user_name}`);

            } catch (err: any) {
                console.error(err);
                
                setMessage(errorMessage(err), "error");
            }

            setLoading(false);
            return;
        }
        
        logEvent("novo_verificado", {
            categoria: "Verificado",
            acao: "Novo verificado",
        });

        try {
            const response = await axios.post(`${PACOCA_API_URL}/verified`, {
                months, gateway: paymentMethod
            },{
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            });

            if(paymentMethod == "wallet"){
                setMessage(user?.stamps?.includes("blue") || user?.stamps?.includes("black") ? t("premium.sealRenewed") : t("premium.verifiedAdded"), "success");
                setUser(user ? { ...user, stamps: [...(user?.stamps || []), user?.is_company ? "black" : "blue"] } : user);
                cancel()
                navigate(`/@${user?.user_name}`)
                return;
            }

            setTransaction(response.data.transaction);
            // Se for PIX, mostra QR e copia-e-cola
            if(response.data.gateway_data?.qrcode){
                setQrCode(response.data.gateway_data.qrcode);
                setCopyPaste(response.data.gateway_data.copyPaste);
            }
            setForceShowForm(false);

            // setQrCode(response.data.qrcode);
            // setPix(response.data.pix);
        } catch (err: any) {
            const messageError = errorMessage(err);
                                    
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
            } else {
                setMessage(messageError, "error")
            }
            console.error(messageError);
            console.error(err);
        }
        setLoading(false)
    }

    // Mapeamento para os IDs que o MP aceita
    const lookupBin = async (number: string) => {
        const digits = number.replace(/\s/g, "");
        if (digits.length < 6) {
            setDetectedBrand("");
            return;
        }

        const bin = digits.slice(0, 6);
        setLoadingBin(true);

        try {
            const res = await axios.get(
                `https://api.mercadopago.com/v1/payment_methods/search`,
                { params: { public_key: MP_PUBLIC_KEY, bin, marketplace: "NONE" } }
            );

            // Filtra apenas cartões de crédito — ignora débito, pré-pago, etc.
            const method = res.data.results?.find(
                (r: any) => r.payment_type_id === "credit_card"
            );

            if (method?.id) {
                setDetectedBrand(method.id);
                setCardErrors(p => ({ ...p, number: "" })); // limpa erro anterior
            } else {
                setDetectedBrand("");
                setCardErrors(p => ({ ...p, number: t("errors.input.invalid", { field: t("generics.value") }) }));
            }
        } catch {
            setDetectedBrand("");
        } finally {
            setLoadingBin(false);
        }
    };

    useEffect(() => {
        if(total > walletBalance) setPaymentMethod("gerencianet_pix");
    }, [total])

    const formatDate = (date: any) => {
        const d = new Date(date + 'T00:00:00'); // força horário local meia-noite
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }

    const formatDateTwo = (date: any) => {
        const d = new Date(date);
        if (isNaN(d.getTime())) return t("premium.invalidDate");

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const next = () => {
        if(step > 1){
            submit()
            return;
        }
        setStep(step + 1);
    }

    const getVerifiedUntil = () => {
        var base = user?.next_payment
            ? new Date(String(user?.next_payment)?.replace(" ", "T"))
            : new Date();
        base.setDate(base.getDate() + 1);
        base = base;

        if (isNaN(base.getTime())) return t("premium.invalidDate");

        base.setMonth(base.getMonth() + months);
        return formatDateTwo(base);
    };
    
     
      
return (
        <>
            <Screen paddingTopTitle={true} title={window.innerWidth <= 850 ? t("settings.verified") : " "}>
                <Helmet>
                    <title>{`Paçoca - ${t("premium.metaTitle")}`}</title>
                    <meta name="description" content={t("premium.metaDescription")} />
                    <meta name="keywords" content={t("premium.metaKeywords")} />
                    <meta name="author" content="Paçoca Inc." />
                    <meta property="og:title" content={`Paçoca - ${t("premium.metaTitle")}`} />
                    <meta property="og:description" content={t("premium.metaDescription")} />
                    <meta property="og:image" content="/img/link-preview.png?v=1" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="630" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`Paçoca - ${t("premium.metaTitle")}`} />
                    <meta name="twitter:description" content={t("premium.metaDescription")} />
                    <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <div className="padding-big-screen">
                    <form className="bank-tx" onSubmit={(e) => e.preventDefault()}>

                        {/* ---------- FORMULÁRIO (steps 1 e 2) ---------- */}
                        {forceShowForm || (!qrCode && !user?.stamps?.includes("blue") && !user?.stamps?.includes("black")) ? (
                            <>
                                <div className="bank-hero">
                                    <div className="foc-premium-icon">
                                        <BadgeCheck size={26} />
                                    </div>
                                    <h5 className="bank-hero-title">
                                        {user?.is_company ? t("company.requestSeal.stamp") : t("settings.verified")}
                                    </h5>
                                    <p className="foc-qr-hint" style={{ marginBottom: 0 }}>
                                        <span className="current-value">
                                            {user?.is_company ? t("company.requestSeal.value") : t("premium.value")}
                                        </span>{" "}
                                        <span className="old-value">
                                            {user?.is_company ? t("company.requestSeal.oldValue") : t("premium.oldValue")}
                                        </span>
                                    </p>
                                </div>

                                {step === 1 && (
                                    <div className="foc-step-body">
                                        {user?.is_company ? <RequestCompanySealStep1 /> : <PremiumUserStep1 />}
                                    </div>
                                )}

                                {step === 2 && (
                                    <>
                                        <div className="bank-section-label">{t("premium.duration")}</div>
                                        <select
                                            value={months}
                                            className="foc-key-input"
                                            style={{ marginBottom: errorsInput.months ? 6 : 18, width: "100%" }}
                                            onChange={(e) => setMonths(Number(e.target.value))}
                                        >
                                            {[...Array(12)].map((_, i) => {
                                                const mes = i + 1;
                                                return (
                                                    <option key={mes} value={mes}>
                                                        {t("premium.month", { count: mes })}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        {errorsInput.months && (
                                            <div role="alert" className="foc-error-msg" style={{ marginTop: -10, marginBottom: 14 }}>
                                                {errorsInput.months[0]}
                                            </div>
                                        )}

                                        <div className="bank-section-label">{t("premium.paymentMethod")}</div>
                                        <div className="foc-pay-list">
                                            <label className={`foc-pay-item ${paymentMethod === "wallet" ? "sel" : ""} ${total > walletBalance ? "foc-pay-disabled" : ""}`}>
                                                <input
                                                    type="radio"
                                                    name="payMethod"
                                                    className="sr-only"
                                                    checked={paymentMethod === "wallet"}
                                                    disabled={total > walletBalance}
                                                    onChange={() => setPaymentMethod("wallet")}
                                                />
                                                <span className={`foc-radio ${paymentMethod === "wallet" ? "foc-radio-sel" : ""}`} />
                                                <span className="foc-pay-icon"><WalletIcon size={16} /></span>
                                                <div>
                                                    <div className="foc-pay-title">{t("premium.walletBalance")}</div>
                                                    <div className="foc-pay-sub">
                                                        {loadinWallet ? (
                                                            <span className="foc-placeholder-inline" />
                                                        ) : (
                                                            t("premium.walletAvailable", { value: walletBalance.toFixed(2).replace(".", ",") })
                                                        )}
                                                    </div>
                                                </div>
                                                {!loadinWallet && (
                                                    <span className={`foc-pay-tag ${total > walletBalance ? "foc-pay-tag-warn" : "foc-pay-tag-ok"}`}>
                                                        {total > walletBalance ? t("premium.walletInsufficient") : t("premium.walletAvailableTag")}
                                                    </span>
                                                )}
                                            </label>

                                            <label className={`foc-pay-item ${paymentMethod === "gerencianet_pix" ? "sel" : ""}`}>
                                                <input
                                                    type="radio"
                                                    name="payMethod"
                                                    className="sr-only"
                                                    checked={paymentMethod === "gerencianet_pix"}
                                                    onChange={() => setPaymentMethod("gerencianet_pix")}
                                                />
                                                <span className={`foc-radio ${paymentMethod === "gerencianet_pix" ? "foc-radio-sel" : ""}`} />
                                                <span className="foc-pay-icon"><QrCodeIcon size={16} /></span>
                                                <div>
                                                    <div className="foc-pay-title">{t("premium.pix")}</div>
                                                    <div className="foc-pay-sub">{t("premium.pixDescription")}</div>
                                                </div>
                                            </label>

                                            <label className={`foc-pay-item ${paymentMethod === "mercadopago_card" ? "sel" : ""}`}>
                                                <input
                                                    type="radio"
                                                    name="payMethod"
                                                    className="sr-only"
                                                    checked={paymentMethod === "mercadopago_card"}
                                                    onChange={() => setPaymentMethod("mercadopago_card")}
                                                />
                                                <span className={`foc-radio ${paymentMethod === "mercadopago_card" ? "foc-radio-sel" : ""}`} />
                                                <span className="foc-pay-icon"><CreditCard size={16} /></span>
                                                <div>
                                                    <div className="foc-pay-title">{t("premium.creditCard")}</div>
                                                    <div className="foc-pay-sub">Visa, Mastercard, Elo, Hipercard</div>
                                                </div>
                                            </label>
                                        </div>

                                        {paymentMethod === "mercadopago_card" && (
                                            <div className="foc-card-form">
                                                <div className="foc-key-wrap">
                                                    <div className="foc-key-label">{t("premium.cardNumber")}</div>
                                                    <input
                                                        className={`foc-key-input ${cardErrors.number ? "foc-key-input-error" : ""}`}
                                                        placeholder="0000 0000 0000 0000"
                                                        maxLength={19}
                                                        value={cardData.number}
                                                        onChange={(e) => {
                                                            const masked = maskCardNumber(e.target.value);
                                                            setCardData(p => ({ ...p, number: masked }));
                                                            lookupBin(masked);
                                                        }}
                                                    />
                                                    <p className="foc-pay-sub" style={{ marginTop: 4 }}>
                                                        {t("premium.cardDataSecure")}
                                                    </p>
                                                    {cardErrors.number && <div className="foc-error-msg">{cardErrors.number}</div>}
                                                    {detectedBrand && (
                                                        <small className="foc-pay-sub">
                                                            {loadingBin ? t("premium.checking") : t("premium.cardBrand", { brand: detectedBrand.toUpperCase() })}
                                                        </small>
                                                    )}
                                                </div>

                                                <div className="foc-key-wrap">
                                                    <div className="foc-key-label">{t("premium.cardName")}</div>
                                                    <input
                                                        className={`foc-key-input ${cardErrors.name ? "foc-key-input-error" : ""}`}
                                                        placeholder={t("premium.cardNamePlaceholder")}
                                                        value={cardData.name}
                                                        onChange={(e) => setCardData(p => ({ ...p, name: e.target.value.toUpperCase() }))}
                                                    />
                                                    {cardErrors.name && <div className="foc-error-msg">{cardErrors.name}</div>}
                                                </div>

                                                <div className="foc-card-row">
                                                    <div className="foc-key-wrap">
                                                        <div className="foc-key-label">{t("premium.expiration")}</div>
                                                        <input
                                                            className={`foc-key-input ${cardErrors.expiry ? "foc-key-input-error" : ""}`}
                                                            placeholder="MM/AA"
                                                            maxLength={5}
                                                            value={cardData.expiry}
                                                            onChange={(e) => setCardData(p => ({ ...p, expiry: maskExpiry(e.target.value) }))}
                                                        />
                                                        {cardErrors.expiry && <div className="foc-error-msg">{cardErrors.expiry}</div>}
                                                    </div>
                                                    <div className="foc-key-wrap">
                                                        <div className="foc-key-label">CVV</div>
                                                        <input
                                                            className={`foc-key-input ${cardErrors.cvv ? "foc-key-input-error" : ""}`}
                                                            placeholder="000"
                                                            maxLength={4}
                                                            value={cardData.cvv}
                                                            onChange={(e) => setCardData(p => ({ ...p, cvv: e.target.value.replace(/\D/g, "") }))}
                                                        />
                                                        {cardErrors.cvv && <div className="foc-error-msg">{cardErrors.cvv}</div>}
                                                    </div>
                                                </div>

                                                <label className="foc-checkbox-row">
                                                    <input
                                                        type="checkbox"
                                                        checked={recorrente}
                                                        onChange={(e) => setRecorrente(e.target.checked)}
                                                    />
                                                    <span className="foc-pay-sub">
                                                        {t("premium.renewAutomatically")}
                                                        <small className="foc-pay-sub" style={{ display: "block" }}>
                                                            {t("premium.renewAutomaticallyInfo")}
                                                        </small>
                                                    </span>
                                                </label>
                                            </div>
                                        )}

                                        <div className="foc-price-row" style={{ marginTop: 18, flexDirection: "column", gap: 8 }}>
                                            <div className="w-100 d-flex justify-content-between align-items-center">
                                                <span className="foc-price-label">{t("premium.monthlyFee")}</span>
                                                <span className="foc-price-value" style={{ fontSize: 14 }}>
                                                    R$ {valuePerMonth.toFixed(2).replace(".", ",")}
                                                </span>
                                            </div>

                                            <div className="w-100 d-flex justify-content-between align-items-center">
                                                <span className="foc-price-label">{t("premium.validUntil")}</span>
                                                <span className="foc-price-value" style={{ fontSize: 14 }}>{getVerifiedUntil()}</span>
                                            </div>

                                            <div className="w-100 d-flex justify-content-between align-items-center">
                                                <span className="foc-price-label">{t("premium.total")}</span>
                                                <span className="foc-price-value">R$ {total.toFixed(2).replace(".", ",")}</span>
                                            </div>
                                        </div>

                                        {forceShowForm && (
                                            <button
                                                type="button"
                                                onClick={() => setForceShowForm(false)}
                                                className="foc-cancel-link"
                                            >
                                                {t("generics.cancel")}
                                            </button>
                                        )}
                                    </>
                                )}

                                <div className="foc-actions" style={{ marginTop: 18 }}>
                                    <button type="button" disabled={loading} onClick={next} className="foc-btn foc-btn-primary">
                                        {loading ? <Spinner size="20px" /> : (step === 1 ? t("generics.continue") : t("generics.finish"))}
                                    </button>
                                </div>

                                {step > 1 && (
                                    <button type="button" onClick={() => setStep(1)} className="foc-cancel-link">
                                        {t("generics.cancel")}
                                    </button>
                                )}
                            </>
                        ) : null}

                        {/* ---------- JÁ VERIFICADO ---------- */}
                        {!forceShowForm && !qrCode && (user?.stamps?.includes("blue") || user?.stamps?.includes("black")) ? (
                            <div className="foc-status-card">
                                <div className="foc-status-icon">
                                    <BadgeCheck size={32} />
                                </div>
                                <h3 className="bank-hero-title" style={{ marginBottom: 4 }}>
                                    {user?.next_payment ? t("premium.verifiedUntil", { date: formatDate(user.next_payment) }) : t("premium.verifiedForever")}
                                </h3>
                                {user?.next_payment ? (
                                    <a className="foc-cancel-link" style={{ color: "var(--foc-active)" }} onClick={() => setForceShowForm(true)}>
                                        {t("premium.renew")}
                                    </a>
                                ) : null}
                            </div>
                        ) : null}

                        {user?.subscription_active && user?.next_payment && (
                            <a className="foc-cancel-link" onClick={() => navigate("/verificado/cancelar")}>
                                {t("premium.cancelAutoRenewal")}
                            </a>
                        )}

                        {/* ---------- QR CODE ---------- */}
                        {qrCode ? (
                            <>
                                <div className="foc-status-pill">
                                    <span className="foc-status-dot" />
                                    {t("premium.awaitingPayment")}
                                </div>

                                <p className="foc-qr-hint">{t("premium.qrHint")}</p>
                                <p className="foc-qr-hint" style={{ marginTop: -8 }}>R$ {oldValue ?? valuePerMonth}</p>

                                <div className="foc-qr-view">
                                    <img src={qrCode} width={220} className="foc-qr-img" alt={t("premium.qrCodeAlt")} />
                                </div>

                                <div className="foc-actions">
                                    <button onClick={copyLink} type="button" className="foc-btn foc-btn-primary">
                                        <Clipboard size={15} />
                                        {copiado ? t("premium.copied") : t("premium.copyCode")}
                                    </button>

                                    <button disabled={loadingVerifyPayment} onClick={() => verifyPayment(true)} type="button" className="foc-btn foc-btn-primary">
                                        {loadingVerifyPayment ? <Spinner size="20px" /> : <><CreditCard size={15} /> {t("premium.verifyPayment")}</>}
                                    </button>
                                </div>

                                <button onClick={cancel} type="button" className="foc-cancel-link">
                                    {t("generics.cancel")}
                                </button>
                            </>
                        ) : null}

                    </form>
                </div>
            </Screen>
        </>
    );
};

export default Premium;